import { render, staticRenderFns } from "./function-permission.vue?vue&type=template&id=b899fed6&scoped=true&"
import script from "./function-permission.vue?vue&type=script&lang=js&"
export * from "./function-permission.vue?vue&type=script&lang=js&"
import style0 from "./function-permission.vue?vue&type=style&index=0&id=b899fed6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899fed6",
  null
  
)

export default component.exports